import axios from 'axios';

const httpClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    'content-type': 'application/json',
    'x-api-key': `${process.env.REACT_APP_API_KEY}`
  }
});

export const fetchPPSIS = org => httpClient.get(`/${org}/ppsis`);

export const fetchPPIS = org => httpClient.get(`/${org}/ppis`);

export const fetchConfig = org => httpClient.get(`/${org}/config`);

// added for refresh functionality

export const fetchRefresh = org => httpClient.get(`/${org}/ppsirefresh`);

//added save interactions count post api story 791
export const saveInteractionsCount = data => httpClient.post(`/kitchen/coworker/saveinteractioncount`,data);

//code added SP 763 get market list

export const fetchMarket = org => httpClient.get(`/config/allconfigmarketsppsilanguagecode`);

export const getCaptcha=(org,data)=>httpClient.post(`/${org}/generateCaptcha`,data);

export const saveFeedback=(org,data)=>httpClient.post(`/${org}/saveCoworkerFeedback`,data);

export const cancelFeedback=(clientId)=>httpClient.post(`/${clientId}/cancel`);
